"use client";

import Link from "next/link";
import AppLogo from "@/components/ui/AppLogo";

const footerLinks = {
    Company: [
        { label: "Home", href: "/homepage" },
        { label: "Operations", href: "/operations" },
        { label: "Commercial", href: "/commercial" },
    ],
    Services: [
        { label: "Offtake Agreements", href: "/commercial" },
        { label: "Supply Planning", href: "/operations" },
        { label: "Logistics", href: "/operations" },
    ],
    Legal: [
        { label: "Privacy Policy", href: "#" },
        { label: "Terms of Use", href: "#" },
        { label: "Compliance", href: "#" },
    ],
};

export default function Footer() {
    return (
        <footer
            className="section-navy"
            style={{ borderTop: "1px solid rgba(255,255,255,0.06)" }}
        >
            {/* Main footer body */}
            <div
                className="px-6 lg:px-12 py-16"
                style={{ maxWidth: "1280px", margin: "0 auto" }}
            >
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">
                    {/* Brand column */}
                    <div className="lg:col-span-2 flex flex-col gap-6">
                        <div style={{ 
                        width: "200px", 
                        height: "40px", 
                        overflow: "hidden",
                        display: "flex",
                        alignItems: "center"
                        }}>
                        <img
                            src="/assets/images/logo.svg"
                            alt="GFS Service Ltd."
                            style={{
                            height: "40px",
                            objectFit: "cover"
                            }}
                        />
                        </div>
                        <p
                            className="type-body"
                            style={{ color: "rgba(255,255,255,0.45)", maxWidth: "280px", fontSize: "0.875rem" }}
                        >
                            Strategic antimony supply for global refiners. Transparent terms,
                            logistics-ready delivery, and responsible sourcing.
                        </p>
                        <div style={{ marginTop: "12px" }}>
                        <span
                            className="type-caption"
                            style={{ color: "rgba(255,255,255,0.3)", display: "block", marginBottom: "8px" }}
                        >
                            Head Office
                        </span>

                        {/* Address */}
                        <div style={{ display: "flex", alignItems: "flex-start", gap: "10px", marginBottom: "12px" }}>

                            <p style={{ color: "rgba(255,255,255,0.55)", fontSize: "0.875rem", lineHeight: "1.6", margin: 0 }}>
                            GFS SERVICES LTD.<br />
                            Unit 2001–2005, Floor 20,<br />
                            SJ Infinite 1 Business Complex,<br />
                            349 Vibhavadi-Rangsit Road,<br />
                            Chompon Sub-District, <br/> Chatuchak,<br />
                            Bangkok 10900, Thailand
                            </p>
                        </div>

                        {/* Phone */}
                        <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px" }}>

                            <p style={{ color: "rgba(255,255,255,0.55)", fontSize: "0.875rem", margin: 0 }}>
                            +66 61 113 3442
                            </p>
                        </div>

                        {/* Email */}
                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>

                            <p style={{ color: "rgba(255,255,255,0.55)", fontSize: "0.875rem", margin: 0 }}>
                            info@gfs-apac.com
                            </p>
                        </div>
                        </div>
                    </div>

                    {/* Link columns */}
                    {Object.entries(footerLinks)?.map(([group, links]) => (
                        <div key={group} className="flex flex-col gap-4">
                            <p
                                className="type-subheading"
                                style={{ color: "rgba(255,255,255,0.35)" }}
                            >
                                {group}
                            </p>
                            {links?.map((l) => (
                                <Link
                                    key={l?.label}
                                    href={l?.href}
                                    style={{
                                        color: "rgba(255,255,255,0.55)",
                                        fontSize: "0.875rem",
                                        textDecoration: "none",
                                        transition: "color 150ms",
                                    }}
                                    onMouseEnter={(e) => (e.currentTarget.style.color = "#b91c1c")}
                                    onMouseLeave={(e) => (e.currentTarget.style.color = "rgba(255,255,255,0.55)")}
                                >
                                    {l?.label}
                                </Link>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
            {/* Bottom bar */}
            <div
                className="px-6 lg:px-12 py-5"
                style={{
                    borderTop: "1px solid rgba(255,255,255,0.06)",
                    maxWidth: "1280px",
                    margin: "0 auto",
                }}
            >
                <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
                    <p className="type-caption" style={{ color: "rgba(255,255,255,0.3)" }}>
                        © 2026 GFS Service Ltd. All rights reserved.
                    </p>
                    <div className="flex items-center gap-6">
                        <Link
                            href="#"
                            className="type-caption"
                            style={{ color: "rgba(255,255,255,0.3)", textDecoration: "none" }}
                        >
                            Privacy
                        </Link>
                        <Link
                            href="#"
                            className="type-caption"
                            style={{ color: "rgba(255,255,255,0.3)", textDecoration: "none" }}
                        >
                            Terms
                        </Link>
                        <Link
                            href="#"
                            className="type-caption"
                            style={{ color: "rgba(255,255,255,0.3)", textDecoration: "none" }}
                        >
                            Compliance
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}